import { useEffect, useState } from 'react';
import { Size } from '../../constants/commonEnums';
import { If } from '../Atoms/Conditionals';
import { Loader } from '../Atoms/Loader';
import { checkLoginStatus } from '../Header/utils';
import { AtctaxRegimeTab } from './Atc-calculator-constants';
import Mailer from './mailer';
import PaytaxServices from './paytax-service';
import { TabSwitch } from './switching';
import { ATC_REGIMES, CALCULATOR_DATA } from './types';

export const AtcTaxSummary = ({
  inputTabData,
  renderCalculation,
}: {
  inputTabData: CALCULATOR_DATA;
  renderCalculation: boolean;
}) => {
  const [taxData, setTaxData] = useState<ATC_REGIMES>();
  const [activeTab, setActiveTab] = useState(0);
  const slug = 'advance_tax_calculator_email';
  const date = new Date();
  const year = date.getFullYear();
  const [loggedInStatus, setLoggedInStatus] = useState<{
    status: boolean;
    mail: string | null;
  }>({
    status: false,
    mail: null,
  });

  useEffect(() => {
    handleTaxCall();
  }, [renderCalculation]);

  const commonProps = {
    taxCalculation: taxData,
    activeTab: activeTab,
  };

  const handleTaxCall = async () => {
    try {
      const result = await PaytaxServices.getCalculation(
        '/f/itr/advance_tax_calculator_results/',
        inputTabData
      );

      if (loggedInStatus && loggedInStatus?.mail) {
        await PaytaxServices.sendTaxMail(
          loggedInStatus.mail,
          result,
          slug,
          year
        );
      } else {
        const data = await checkLoginStatus();
        if (data?.isloggedin) {
          try {
            await PaytaxServices.sendTaxMail(data.username, result, slug, year);
          } catch (mailError) {
            console.error('Error sending tax mail:', mailError);
          }
          setLoggedInStatus({
            status: data.isloggedin || false,
            mail: data.username || null,
          });
        }
      }
      setTaxData(result);
    } catch (error) {
      console.error('Error calling API:', error);
    }
  };

  if (!taxData) {
    return (
      <div className="flex justify-center text-s-20 h-96 sm:h-56 mt-7">
        <Loader
          loadingLabel="Calculating your tax details..."
          size={Size.XLARGE}
          loaderUrl={
            'https://assets1.cleartax-cdn.com/cleartax-gst/images/1595828806_pinchy_attention.gif'
          }
        />
      </div>
    );
  }

  return (
    <>
      <div className="gap-20 sm:block tax-graph-wrapper">
        <If condition={!!taxData}>
          <TabSwitch
            tabsData={AtctaxRegimeTab}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            classes="md:w-[239px]"
            commonProps={commonProps}
          />
        </If>
      </div>
      <If condition={!loggedInStatus.status}>
        <div className="pt-6  border-t border-[#EEEEEE] relative top-[-36px] sm:top-[20px] sm:border-none sm:pb-6">
          <Mailer emailData={taxData} slug={slug} year={year} />
        </div>
      </If>
    </>
  );
};
